/* Elektrik: karta techniczna produktu (20.10.2026). Wyszukiwanie parametrow, kopiuj (TSV), CSV, drukuj,
   grupy jako <details> (desktop zawsze otwarte, telefon: 2 pierwsze otwarte), porownanie z zamiennikami
   (Wszystkie / Tylko roznice) i dodawanie zamiennika do koszyka. Delegacja zdarzen na document
   (Horizon przerysowuje sekcje). Plik dolaczany z dwoch snippetow, dlatego straznik ponizej. */
(function(){
  if (window.__elKt) return;
  window.__elKt = true;
  var mq = window.matchMedia('(min-width: 990px)');

  function syncGroups(){
    document.querySelectorAll('.el-kt-g').forEach(function(g){
      var i = parseInt(g.dataset.i || '0', 10);
      g.open = mq.matches ? true : i <= 2;
    });
  }

  function rows(root){
    var out = [];
    root.querySelectorAll('.el-kt-g').forEach(function(g){
      var t = (g.querySelector('.el-kt-g__h h3') || {}).textContent || '';
      g.querySelectorAll('.el-kt-row').forEach(function(r){ out.push([t.trim(), r.dataset.l || '', r.dataset.v || '']); });
    });
    return out;
  }

  function flash(btn, txt){
    var lab = btn.querySelector('span') || btn;
    var prev = lab.textContent;
    lab.textContent = txt;
    btn.classList.add('is-done');
    setTimeout(function(){ lab.textContent = prev; btn.classList.remove('is-done'); }, 1600);
  }

  function copyText(txt){
    if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(txt);
    return new Promise(function(res){
      var ta = document.createElement('textarea'); ta.value = txt; ta.style.position = 'fixed'; ta.style.opacity = '0';
      document.body.appendChild(ta); ta.select(); try { document.execCommand('copy'); } catch (e) {} ta.remove(); res();
    });
  }

  function refreshBubble(){
    return fetch('/cart.js', {headers: {'Accept': 'application/json'}}).then(function(r){ return r.json(); }).then(function(cart){
      document.querySelectorAll('[class*="cart-bubble__text"], [class*="cart-count"]').forEach(function(el){ el.textContent = String(cart.item_count); });
      document.dispatchEvent(new CustomEvent('cart:update', {bubbles: true, detail: {resource: cart, sourceId: 'el-kt', data: {source: 'el-kt', itemCount: cart.item_count}}}));
    }).catch(function(){});
  }

  document.addEventListener('click', function(e){
    var t = e.target;
    if (!t || !t.closest) return;
    var sum = t.closest('.el-kt-g__h');
    if (sum && mq.matches) { e.preventDefault(); return; }

    var b = t.closest('[data-kt]');
    if (b) {
      var root = b.closest('.el-kt-spec');
      if (!root) return;
      var sku = root.dataset.sku || 'produkt';
      var data = rows(root);
      if (b.dataset.kt === 'copy') {
        var tsv = 'Grupa\tParametr\tWartość\n' + data.map(function(r){ return r.join('\t'); }).join('\n');
        copyText((root.dataset.title || '') + ' (' + sku + ')\n' + tsv).then(function(){ flash(b, 'Skopiowano'); });
      } else if (b.dataset.kt === 'csv') {
        var q = function(s){ return '"' + String(s).replace(/"/g, '""') + '"'; };
        var csv = '﻿' + ['Grupa', 'Parametr', 'Wartość'].map(q).join(';') + '\n' + data.map(function(r){ return r.map(q).join(';'); }).join('\n');
        var url = URL.createObjectURL(new Blob([csv], {type: 'text/csv;charset=utf-8'}));
        var a = document.createElement('a'); a.href = url; a.download = sku + '-karta-techniczna.csv';
        document.body.appendChild(a); a.click(); a.remove();
        setTimeout(function(){ URL.revokeObjectURL(url); }, 2000);
        flash(b, 'Pobrano');
      } else if (b.dataset.kt === 'print') {
        root.querySelectorAll('.el-kt-g').forEach(function(g){ g.open = true; });
        document.body.classList.add('el-kt-printing');
        window.print();
      }
      return;
    }

    var m = t.closest('[data-kt-cmp]');
    if (m) {
      var sec = m.closest('.el-kt-cmp');
      var diff = m.dataset.ktCmp === 'diff';
      sec.classList.toggle('is-diffonly', diff);
      sec.querySelectorAll('[data-kt-cmp]').forEach(function(x){
        var on = (x.dataset.ktCmp === 'diff') === diff;
        x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      return;
    }

    var add = t.closest('.el-kt-add');
    if (add) {
      e.preventDefault();
      if (add.dataset.busy === '1') return;
      add.dataset.busy = '1';
      var prev = add.textContent;
      add.textContent = 'Dodaję...';
      fetch('/cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({items: [{id: parseInt(add.dataset.id, 10), quantity: 1}]})})
        .then(function(r){ return r.json().then(function(j){ return {ok: r.ok, j: j}; }); })
        .then(function(res){
          if (res.ok) { add.textContent = 'Dodano ✓'; add.classList.add('is-done'); refreshBubble(); }
          else {
            var d = (res.j && (res.j.description || res.j.message)) || '';
            add.textContent = /stock|zapas|available|dostęp/i.test(d) ? 'Za mało sztuk' : 'Nie udało się';
          }
          setTimeout(function(){ add.textContent = prev; add.classList.remove('is-done'); add.dataset.busy = '0'; }, 1800);
        })
        .catch(function(){ add.textContent = 'Błąd'; setTimeout(function(){ add.textContent = prev; add.dataset.busy = '0'; }, 1800); });
    }
  }, true);

  document.addEventListener('input', function(e){
    var inp = e.target && e.target.closest && e.target.closest('.el-kt-search input');
    if (!inp) return;
    var q = inp.value.trim().toLowerCase();
    var root = inp.closest('.el-kt-spec');
    var any = false;
    root.querySelectorAll('.el-kt-g').forEach(function(g){
      var n = 0;
      g.querySelectorAll('.el-kt-row').forEach(function(r){
        var ok = !q || (r.dataset.q || '').indexOf(q) > -1;
        r.hidden = !ok;
        if (ok) n++;
      });
      g.hidden = n === 0;
      if (q && n) g.open = true;
      if (n) any = true;
    });
    if (!q) syncGroups();
    var em = root.querySelector('.el-kt-empty');
    if (em) em.hidden = any;
  });

  window.addEventListener('afterprint', function(){ document.body.classList.remove('el-kt-printing'); syncGroups(); });
  if (mq.addEventListener) mq.addEventListener('change', syncGroups); else if (mq.addListener) mq.addListener(syncGroups);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncGroups); else syncGroups();
})();
